"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useRef } from "react";
import renderIcon from "../../icons/render-icon.js";
import makeStyles from "../../theming/make-styles.js";
import getItemsAlignment from "../utils/css/get-items-alignment.js";
import { useScrollIntoView } from "../utils/scroll-into-view.js";
import useCombinedRefs from "../utils/use-combined-refs.js";
import { ListContext } from "./list.js";
const useStyles = makeStyles()((theme, { active, alignItems, color, disabled, divider, hoverableItem, hoverableList, wrap }, classes) => {
    const palette = theme.palette(color).list;
    const disabledStyles = {
        color: palette.item.disabled.color,
        backgroundColor: palette.item.disabled.backgroundColor,
        cursor: "not-allowed",
        userSelect: "none",
        pointerEvents: "none",
    };
    const wrapStyles = {
        minWidth: 0,
        overflowWrap: "break-word",
    };
    return {
        item: Object.assign(Object.assign({ "display": "flex", "padding": theme.spacing("sm", "md"), "backgroundColor": hoverableItem
                ? palette.item.hoverableItem.hover.backgroundColor
                : active
                    ? palette.item.hoverableItem.active.backgroundColor
                    : undefined, "cursor": (hoverableItem !== null && hoverableItem !== void 0 ? hoverableItem : hoverableList) ? "pointer" : undefined, "alignItems": getItemsAlignment(alignItems) }, (disabled && disabledStyles)), { "&:hover": Object.assign({ backgroundColor: (hoverableItem !== null && hoverableItem !== void 0 ? hoverableItem : hoverableList) ? palette.item.hoverableItem.hover.backgroundColor : undefined }, (disabled && disabledStyles)), "&:active": Object.assign({ backgroundColor: (hoverableItem !== null && hoverableItem !== void 0 ? hoverableItem : hoverableList) ? palette.item.hoverableItem.active.backgroundColor : undefined }, (disabled && disabledStyles)), "&:not(:first-of-type)": {
                borderTop: divider ? `${theme.size(1)} solid ${palette.borderColor}` : undefined,
            } }),
        leftIcon: {
            flexShrink: 0,
        },
        rightIcon: {
            flexShrink: 0,
        },
        text: Object.assign(Object.assign({ flexGrow: 1 }, (wrap
            ? wrapStyles
            : {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            })), { [`.${classes.leftIcon} + &`]: {
                marginLeft: theme.spacing(12),
            }, [`& + .${classes.rightIcon}`]: {
                marginLeft: theme.spacing(12),
            } }),
    };
});
export const ListItem = React.forwardRef(function ListItem(_a, ref) {
    var { active, alignItems, children, className, disabled, divider, hoverable, leftIcon, rightIcon, scrollToView } = _a, props = __rest(_a, ["active", "alignItems", "children", "className", "disabled", "divider", "hoverable", "leftIcon", "rightIcon", "scrollToView"]);
    const context = useContext(ListContext);
    const { classes, cx } = useStyles({
        active,
        alignItems: alignItems || context.alignItems,
        color: context.color,
        disabled,
        divider: divider !== null && divider !== void 0 ? divider : context.bordered,
        hoverableList: context.hoverable,
        hoverableItem: hoverable,
        wrap: context.wrap,
    });
    const innerRef = useRef(null);
    const combinedRef = useCombinedRefs(ref, innerRef);
    useScrollIntoView(scrollToView, innerRef);
    return (_jsxs("li", Object.assign({ ref: combinedRef, className: cx(classes.item, className), "data-component": "list-item" }, props, { children: [renderIcon(leftIcon, classes.leftIcon), _jsx("div", { className: classes.text, children: children }), renderIcon(rightIcon, classes.rightIcon)] })));
});
export default ListItem;
//# sourceMappingURL=list-item.js.map